export const CREATE_DAYOFF = 1;
export const UPDATE_DAYOFF = 2;
export const CONFIRM_DIALOG = 3;
export const DOCUMENT_DIALOG = 4;
export const START_LEAVE_DIALOG = 5;
export const EDIT_DAYOFF = 6;
export const DAYOFF_TYPE_DIALOG = 7;
export const DOCUMENT_CRUD_DIALOG = 8;
export const DAYOFF_DOCUMENT_DIALOG = 9;
export const DEPARTMENT_DIALOG = 10;
export const TEAM_DIALOG = 11;
export const CATEGORY_DIALOG = 12;
export const BRAND_DIALOG = 13;
export const MODEL_DIALOG = 14;
export const EQUIPMENT_DIALOG = 15;
export const USED_EQUIPMENT_DIALOG = 16;
export const GIVE_BACK_EQUIPMENT_DIALOG = 17;
